import { createApp } from '@backstage/frontend-defaults';
import catalogPlugin from '@backstage/plugin-catalog/alpha';
import { navModule } from './modules/nav';
import { authModule } from './modules/auth';

// Other community plugins (adr, sonarqube, tech-radar, …) are auto-discovered
// from packages/app/package.json dependencies via `app.packages: all` in
// app-config.yaml. No explicit import required — the build system injects
// them through window["__@backstage/discovered__"] at runtime.
export default createApp({
  features: [catalogPlugin, navModule, authModule],
});
